import React from 'react';
import { message, Upload } from 'antd';
import BaseComponent from '../../../../base/BaseComponent';
import $ from 'jquery';
import UploadWall from '../../../../components/upload/UploadWall';
import contentHandle from '../../util/content/contentHandle';
import { uuid } from '../../../../utils';

class WordImport extends BaseComponent {
    
    constructor(props) {
        super(props);

        this.state = {};
        this.uploadRef = React.createRef();
    }

    render() {
        return (
            <>
                <Upload
                    // ref={this.uploadRef}
                    accept={".doc,.docx"}
                    name="multipartFile"
                    // action="/cm-sites-media-consumer/position/handler/wordInput"
                    customRequest={({file})=>{
                        const form = new FormData()
                        form.append("multipartFile",file)
                        this.request({
                            url: "/cm-sites-media-consumer/position/handler/wordInput",
                            method: "post",
                            body: form,
                            contentType: "upload",
                            callBack: (response)=>{
                                console.log(response,file);
                                this.wordImportEditor(response,file);
                            },
                            errorCallBack: (error)=>{

                            }
                        })
                    }}
                    // showUploadBtn={false}
                    // showUploadDisplayBtn={true}
                    // onSuccess={(response,file)=>{
                    //     console.log(response,file);
                    //     // if (response.status === 200) {
                    //     //     message.success(response?.message);
                    //     // }else {
                    //     //     message.error(response?.message);
                    //     // }
                    // }}
                    // onError={(error)=>{
                    //     message.error(error);
                    // }}
                >
                    <div ref={this.uploadRef}></div>
                </Upload>
            </>
        )
    }

    wordUpload() {
        console.log(this.uploadRef.current)
        // this.uploadRef.current.uploadDisplayBtnClick();
        this.uploadRef.current.click();
    }

    wordImportEditor(data,file) {
        if(data && data.includes("<style")) {
            // 过滤style标签
            data = this.removeStyleDom(data);
        }
        // let srcList = [];
        // $(`<div>${data}</div>`).find("img").each(function(){
        //     let src = $(this).attr("src");
        //     if(src){
        //         srcList.push(src);
        //     }
        // });
        let fun = (picList)=>{
            this.wordKey = uuid();
            // 存在导入的word每一段外面都是div，但是没有最外层div，所以这里暂不能直接去掉最外层div
            // let handleNames = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("editor.content.word.import.after.handler.names", 'removeTopDiv,changeImage');
            let handleNames = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("editor.content.word.import.after.handler.names", 'removeTopDivMore,changeImage,removeA');
            let handleNamesArr = handleNames.split(",");
            // 因jq无法解析html和body标签，所以这里将相关标签进行转移
            handleNamesArr.unshift("addHtmlAndBody");
            // 结束时对html和body进行还原
            handleNamesArr.push("removeHtmlAndBody");
            
            let content = contentHandle(handleNamesArr, data, picList);
            this.props.editor.setContent(content);
            let information = this.props.editor?.getInformation(false);
            this.props.editor.setCurrentInformation({...information, title: file?.name ? file.name.replace(/(.*)\.[^\.]+/, "$1") : ""});
            // window.loading.hide();
            // this.setState({});
        };
        fun([]);
        // if(srcList.length === 0){
        //     fun([]);
        // }else{
        //     window.loading.show(true);
        //     this.request({
        //         url: "/storage/getStorageFileListByUrls",
        //         body:{
        //             urls: srcList.join(",")
        //         },
        //         method:"post",
        //         loading:false,
        //         callBack:(picList)=>{
        //             fun(picList);
        //         }
        //     });
        // }
    }

    removeStyleDom = (html) => {
        // 处理html标签
        html = html.replace(/html/g,'rmt_html').replace(/head/g,'rmt_head').replace(/body/g,'rmt_body');
        // 创建虚拟的父元素并将HTML内容作为子元素
        const $parent = $("<div>").html(html);
        // 获取所有style标签的内容
        let styles = $parent.find("style").text();
        if(styles?.length) {
            styles = styles.replace(/\n/g,'');
        } else {
            return html
        }
        // 移除所有style标签
        $parent.find("style").remove();
        $parent.find("title").remove();
        let styleArr = styles.split('}');
        styleArr?.length && styleArr.forEach(style=>{
            if(style) {
                let c = style.split('{');
                if(c.length === 2) {
                    let cla = c[0];
                    let css = c[1];
                    if(cla && css) {
                        if($parent.find(cla)) {
                            $parent.find(cla).attr("style", function (index, oldStyle) {
                                return  "" + css + (oldStyle || "");
                            });
                        }
                    }
                }
            }
        });
        // 获取处理后的HTML
        let processedHtml = $parent.html();
        // 处理html标签
        processedHtml = processedHtml.replace(/rmt_html/g,'html').replace(/rmt_head/g,'head').replace(/rmt_body/g,'body');
        return processedHtml
    };
}
export default WordImport;